module.exports = __webpack_public_path__ + "static/lighting-carousel-hasAutoplay-2ef8e5e060ac46afbf09e1cad9f5d2eb.png";